function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + ';' + expires + ';path=/';
}

function getCookie(name) {
  const decoded = decodeURIComponent(document.cookie || '');
  const parts = decoded.split(';');
  for (let i = 0; i < parts.length; i++) {
    const c = parts[i].trim();
    if (c.indexOf(name + '=') === 0) return c.substring(name.length + 1);
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
}

function setChunked(name, value, days) {
  const str = typeof value === 'string' ? value : JSON.stringify(value);
  const max = 3500;
  const parts = Math.ceil(str.length / max);
  setCookie(name + '_parts', String(parts), days);
  for (let i = 0; i < parts; i++) {
    const chunk = str.slice(i * max, (i + 1) * max);
    setCookie(name + '_part_' + i, chunk, days);
  }
}

function getChunked(name) {
  const partsStr = getCookie(name + '_parts');
  if (!partsStr) return null;
  const parts = parseInt(partsStr, 10);
  if (!parts || parts < 1) return null;
  let out = '';
  for (let i = 0; i < parts; i++) {
    const chunk = getCookie(name + '_part_' + i) || '';
    out += chunk;
  }
  return out;
}

function deleteChunked(name) {
  const partsStr = getCookie(name + '_parts');
  const parts = parseInt(partsStr || '0', 10);
  deleteCookie(name + '_parts');
  for (let i = 0; i < parts; i++) deleteCookie(name + '_part_' + i);
}

export { setCookie, getCookie, deleteCookie, setChunked, getChunked, deleteChunked };